module.exports = __webpack_public_path__ + "img/usm_blue.050e7c64.svg";